import { useId } from "react";

// On-screen mock of the printed jersey back: arched NAME above a big NUMBER.
// Mirrors the actual print produced by backend/personalization_render.py.
export const JerseyBackPreview = ({ name, number, className = "" }) => {
  const id = useId().replace(/:/g, "");
  const displayName = (name || "YOUR NAME").toUpperCase();
  const displayNum = number || "10";
  const len = displayName.length;
  const nameFont = len > 9 ? 66 : len > 7 ? 78 : len > 5 ? 90 : 102;

  return (
    <div
      className={`relative w-full rounded-sm overflow-hidden flex flex-col items-center justify-center ${className}`}
      style={{ aspectRatio: "4 / 5", containerType: "inline-size", background: "radial-gradient(circle at 50% 35%, #2a2a2a 0%, #141414 70%)" }}
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{ backgroundImage: "repeating-linear-gradient(45deg,#fff 0 2px,transparent 2px 6px)" }}
      />
      <svg viewBox="0 0 400 170" className="w-[94%] mt-[9%]" style={{ overflow: "visible" }} aria-hidden="true">
        <defs>
          <path id={`arc-${id}`} d="M 6 150 Q 200 6 394 150" fill="none" />
        </defs>
        <text
          data-testid="preview-name"
          fill="#ffffff"
          stroke="rgba(0,0,0,0.85)"
          strokeWidth="3"
          fontFamily="Anton, sans-serif"
          fontSize={nameFont}
          letterSpacing="1.5"
          style={{ paintOrder: "stroke" }}
        >
          <textPath href={`#arc-${id}`} startOffset="50%" textAnchor="middle">
            {displayName}
          </textPath>
        </text>
      </svg>
      <span
        data-testid="preview-number"
        className="font-anton leading-none text-white -mt-[5%]"
        style={{
          fontSize: "min(46cqw, 156px)",
          WebkitTextStroke: "3px rgba(0,0,0,0.85)",
          textShadow: "0 4px 12px rgba(0,0,0,0.6)",
        }}
      >
        {displayNum}
      </span>
    </div>
  );
};
